import React from 'react';
import cx from 'classnames';
import s from './top.module.scss';
import { contentList } from './contentList';
import { useScrollContext } from '../../context/ScrollContext';
import HeaderBackgroundMobileJpg from '../../../../app/assets/images/header_background_mobile.jpg';
import HeaderBackgroundTabletJpg from '../../../../app/assets/images/header_background_tablet.jpg';
import HeaderBackgroundDesktopJpg from '../../../../app/assets/images/header_background_desktop.jpg';
import DecorImage from '../../../../app/assets/images/decor/decor-2.jpg';
import { handleHeaderOrderTracking } from '../../helpers/trackingsHelper';

export const Top = ({ page = 'main' }) => {
  const { firstLine, secondLine } = contentList[page] || contentList.main;
  const { setScrollToElement } = useScrollContext();

  const handleScroll = () => {
    setScrollToElement('order');
    handleHeaderOrderTracking();
  };

  const handleCallBack = () => {
    if (window.jivo_api) {
      window.jivo_api.open({ start: 'call' });
    }
  }

  return (
    <div className={s.heading}>
      <div className={s.heading__container}>
        <div className={s.heading__wrap}>
          <h1 className={s.heading__caption}>{firstLine}</h1>
          <span className={s.heading__text}>{secondLine}</span>
          <div className={s.heading__buttons}>
            <div className={cx(s.heading__btn_wrap, s.heading__btn_wrap_first)}>
              <button onClick={handleScroll} data-target="top-order" className={cx(s.btn, s.main)}>Заказать</button>
            </div>
            <div className={cx(s.heading__btn_wrap, s.heading__btn_wrap_second)}>
              <button onClick={handleCallBack} className={cx(s.btn, s.btn_grey)}>перезвонить мне</button>
            </div>
          </div>
        </div>
        <div className={s.heading__image}>
          <picture>
            <source srcSet={HeaderBackgroundMobileJpg} media="(max-width: 500px)" type="image/jpeg" />
            <source srcSet={HeaderBackgroundTabletJpg} media="(min-width: 501px) and (max-width: 1023px)" type="image/jpeg" />
            <source srcSet={HeaderBackgroundDesktopJpg} media="(min-width: 1024px)" type="image/jpeg" />
            <img src={HeaderBackgroundMobileJpg} alt="Polza diet" />
          </picture>
        </div>
      </div>
      <img src={DecorImage} alt="Decor diet" className={cx(s.decor, 'lazy-landing')} />
    </div>
  );
};
